module.exports = require("./src/validatebarcode");
